import { useState } from "react";
import { Button } from "../../Button";
import { cn } from "../../cn";
import { NotificationBadge } from "../../NotificationBadge";
import { IconChevronDown } from "../../Icons";


type TSideMenuListItemProps = {
  IconComponent?: React.ComponentType<React.SVGProps<SVGSVGElement>>,
  label: string,
  to?: string,
  exact?: boolean,
  children?: React.ReactNode,
  subItem?: boolean;
  count?: number;
  max?: number;
  useNotificationBadge?: boolean;
  onPress?: () => void;
  excludeFromTabOrder?: boolean;
  active?: boolean;
  location?: {
    pathname: string;
  }
}

export const SideMenuListItem = ({IconComponent, active: propActive, exact, label, to, children, subItem, count, max, useNotificationBadge, onPress, excludeFromTabOrder, location}: TSideMenuListItemProps) => {
  const [showSubmenu, setShowSubmenu] = useState(false);
  const active = propActive ? true : (
    exact ? location?.pathname === to : location?.pathname.startsWith(to || 'INVALID_TO_PATH')
  );

  return (<>
    <Button unstyled to={to} className={cn(
      'group py-3 px-4 justify-between hover:bg-neutral-200 flex items-center text-text-light hover:text-text',
      subItem && 'pl-8',
      active ? 'text-text hover:text-text' : ''
    )} onPress={() => {
      if(!to) {
        setShowSubmenu(!showSubmenu);
      }
      if(onPress) {
        onPress();
      }
    }} excludeFromTabOrder={excludeFromTabOrder}>
      <div className={cn(
        'flex gap-2 items-center',
        active ? 'underline group-hover:underline decoration-gold-500 decoration-2 underline-offset-4 ' : '',
      )}>
        {IconComponent && <IconComponent className='w-5 h-5'/> || ''}
        <div className='font-semibold leading-6 tracking-wide text-md'>{label}</div>
      </div>
      <div className='flex gap-2 items-center'>
        {count && !useNotificationBadge && <div className='px-2 font-bold leading-5 text-center'>{count}</div> || ''}
        {count && useNotificationBadge && <NotificationBadge className='' count={count} max={max}/> || ''}
        {children && <IconChevronDown className={cn('w-5 h-5 transition-transform duration-100', showSubmenu && 'transform rotate-180')}/> || ''}
      </div>
    </Button>
    {children && showSubmenu && <div className='flex flex-col'>{children}</div> || ''}
  </>)
}